import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { getAdminsList, getAdminTypesList, createAdmin, updateAdmin, deleteAdmin } from "../api/admin";

export const useGetAdminsList = () => {
    return useQuery({
        queryKey: ['admin-list'],
        queryFn: getAdminsList,
    });
};

export const useGetAdminTypes = () => {
    return useQuery({
        queryKey: ['admin-types-list'],
        queryFn: getAdminTypesList,
    });
};

export const useCreateAdmin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: createAdmin,
        onSuccess: () => {
            queryClient.invalidateQueries(['admin-list']);
        },
    });
};

export const useUpdateAdmin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateAdmin,
        onSuccess: () => {
            queryClient.invalidateQueries(['admin-list']);
        },
    });
};

export const useDeleteAdmin = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteAdmin,
        onSuccess: () => {
            queryClient.invalidateQueries(['admin-list']);
        },
    });
};